import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { BackofficeDeleteClustersResponseDataSchema, DeleteClustersKeysSchema } from "schema"
import { z } from "zod"

type DeleteClustersData = z.infer<typeof DeleteClustersKeysSchema>
type DeleteClustersResponse = z.infer<typeof BackofficeDeleteClustersResponseDataSchema>

export const useDeleteBackofficeClustersMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: DeleteClustersData) => {
      const response = await axios.delete<{ data: DeleteClustersResponse }>(
        "/backoffice/clusters/bulk",
        { data },
      )
      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["backofficeClusterKeys"],
      })
    },
  })
}
